import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Card, CardBody } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { Home } from "react-feather";
import Select from "react-select";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Bar } from "react-chartjs-2";

export default function GodReportsByJob() {
    const search = useLocation().search;
    const commit = new URLSearchParams(search).get("commit");
    const searchParams = {
        fromDate: new URLSearchParams(search).get("filter[from]"),
        toDate: new URLSearchParams(search).get("filter[to]"),
        machineName: new URLSearchParams(search).get("filter[machine_name]"),
        jobType: new URLSearchParams(search).get("filter[job_type]")
    }
    const now = new Date()
    const [labels, setLabels] = useState([]);
    const [machineNameOptions, setMachineNameOptions] = useState([]);
    const [machineName, setMachineName] = useState({ label: 'All', value: 'All' });
    const [data, setData] = useState([])
    const [fromDate, setFromDate] = useState(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7))
    const [toDate, setToDate] = useState(now);
    const [loading, setLoading] = useState(false);
    const [jobType, setJobType] = useState({ label: 'All', value: 'All' });
    const [jobTypeOptions, setJobTypeOptions] = useState([])
    const options = {


        plugins: {

            title: {
                display: true,
                text: ''
                ,
            },

        },
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            
            y: {
                stacked: true,
            },
        },
    };

    useEffect(() => {
        setSearchParamsData()
    }, []);

    function setSearchParamsData() {
        if (searchParams.fromDate && searchParams.fromDate != fromDate) {
            setFromDate(new Date(searchParams.fromDate))
        }
        if (searchParams.toDate && searchParams.toDate != toDate) {
            setToDate(new Date(searchParams.toDate))
        }
        if (searchParams.machineName && machineName != machineName.value) {
            setMachineName({ label: searchParams.machineName, value: searchParams.machineName })
        }
        if(searchParams.jobType && searchParams.jobType != jobType.value){
            setJobType({label: searchParams.jobType , value: searchParams.jobType})
        }
        if (commit == 'Get Data') {

            fetchData(searchParams.fromDate, searchParams.toDate, searchParams.machineName,searchParams.jobType)
        }
        else {
            fetchIntialData();
        }
    }

    function fetchData(FromDate = fromDate, ToDate = toDate, MachineName = machineName.value, JobType=jobType.value) {
        axios.get(`/api/v1/internal/god_report/search_by_job_type?filter[from]=${moment(FromDate).format("YYYY/MM/DD")}&filter[to]=${moment(ToDate).format("YYYY/MM/DD")}&filter[machine_name]=${MachineName}&filter[job_type]=${JobType}`)
            .then(res => {
                setLabels(res.data.date_range);
                setData(res.data.watcher_counts);
                setMachineNameOptions(res.data.all_machines.map(item => ({ label: item, value: item })));
                setJobTypeOptions(res.data.job_types.map(item =>({label: item, value: item})))
                
            })
            .catch(err => {
                console.error(err?.message || 'Oops something went wrong')
            })
    }
    function fetchIntialData() {
        axios.get(`/api/v1/internal/god_report/fetch_god_reports_by_job_type?filter[from]=${moment(fromDate).format("YYYY/MM/DD")}&filter[to]=${moment(toDate).format("YYYY/MM/DD")}&filter[machine_name]=${machineName.value}&filter[job_type]=${jobType.value}`)
            .then(res => {
                setLabels(res.data.date_range);
                setData(res.data.data);
                setMachineNameOptions(res.data.all_machines.map(item => ({ label: item, value: item })));
                setJobTypeOptions(res.data.job_types.map(item =>({label: item, value: item})))

            })
            .catch(err => {
                console.error(err?.message || 'Oops something went wrong')
            })
    }
    const handleGetData = () => {
        window.location.href = `/internal/god_report/search_by_job_type?filter[from]=${moment(fromDate).format("YYYY/MM/DD")}&filter[to]=${moment(toDate).format("YYYY/MM/DD")}&filter[machine_name]=${machineName.value}&filter[job_type]=${jobType.value}&commit=${'Get Data'}`
    }


    return <Container fluid>
        <div className="page-title">
            <Row>
                <Col xs="6">
                    <h3> Internal Dashboard</h3>
                </Col>
                <Col xs="6">
                    <Breadcrumb>
                        <BreadcrumbItem>
                            <Link to={'/internal'}>
                                <Home />
                            </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem className="fw-bold">
                            {commit == 'Get Data' ? <a className="link-primary fw-normal" href={'/internal/god_report/fetch_god_reports_by_job_type'}> God Reports by Job Type</a> : ' God Reports by Job Type'}
                        </BreadcrumbItem>
                        {commit == 'Get Data' && <BreadcrumbItem className="fw-bold">
                            Search
                        </BreadcrumbItem>}
                    </Breadcrumb>
                </Col>
            </Row>
        </div>
        <Card>
            <CardBody>
                <Row>
                    <Col sm="9">
                        <label className="fw-bold">Job Type</label>
                        <Select 
                            options={jobTypeOptions}
                            value={jobType}
                            onChange={option => setJobType(option)} />
                    </Col>
                </Row>
                <Row className="align-items-end">
                    <Col sm="3">
                        <label className="fw-bold">From Date</label>
                        <DatePicker
                            className="form-control"
                            placeholderText="Select Date"
                            maxDate={now}
                            selected={fromDate ? new Date(fromDate) : fromDate}
                            dateFormat={"YYY/MM/dd"}
                            onChange={date => setFromDate(date)} />
                    </Col>
                    <Col sm="3">
                        <label className="fw-bold">To Date</label>
                        <DatePicker
                            className="form-control"
                            selected={toDate ? new Date(toDate) : toDate}
                            placeholderText="Select Date"
                            maxDate={now}
                            dateFormat={"YYY/MM/dd"}
                            onChange={date => setToDate(date)} />
                    </Col>
                    <Col sm="3">
                        <label className="fw-bold">Machine Name</label>
                        <Select
                            options={machineNameOptions}
                            value={machineName}
                            onChange={option => setMachineName(option)} />
                    </Col>
                    <Col sm="3">
                        <button className="btn btn-success w-100" onClick={handleGetData}>Get Data</button>
                    </Col>
                </Row>

            </CardBody>
        </Card>
        <Card>
            <CardBody>
                <center>
                    <span className="fw-bold">Job Type God Report</span><br />
                    Notes: We are showing the job type and its watcher counts in Below Graph(Ex: resque_web: 3, here job type - resque_web and watcher counts - 3)
                </center>
                <Bar
                    height={200}
                    options={options}
                    data={{
                        labels: labels,
                        datasets: data
                    }} />
            </CardBody>
        </Card>
    </Container>
}